import { DEFAULT_SECTION_ROLES, ADMIN_ROLES } from './roles';

/**
 * Returns true if `role` can access `section`.
 *
 * Phase 1: uses DEFAULT_SECTION_ROLES (hardcoded).
 * Phase 2: pass storedPermissions = session.user.rolePermissions; admin/superadmin
 *   always return true regardless of stored config.
 */
export function canAccessSection(section, role, storedPermissions = null) {
    if (!role) return false;
    if (ADMIN_ROLES.includes(role)) return true;

    if (storedPermissions?.[role]?.sections) {
        return storedPermissions[role].sections.includes(section);
    }

    return (DEFAULT_SECTION_ROLES[section] || []).includes(role);
}
